import React from 'react';
import get from 'lodash.get';
import { getSharedRatesSection, DefaultRatesSection } from '../shared/runningGirlHelper';
import { MEASURE } from '../../../constants/reading/MeasuresConstants';
import { getWordEnding } from '../../../utils/shared/commonUtils';

const { LNF, WRF, ORF, NWF_CLS, NWF_WRC, PSF, ORF_ACC, RAN } = MEASURE;

export const getScoreSection = (score, measure) => {
    const SCORE_SECTION = {
        [WRF]: `${score} Word${getWordEnding(score)} Correct/Minute`,
        [ORF]: `${score} Word${getWordEnding(score)} Correct/Minute`,
        [ORF_ACC]: `${score}%`,
        [LNF]: `${score} Letter Name${getWordEnding(score)}/Minute`,
        [PSF]: `${score} Segment${getWordEnding(score)}/Minute`,
        [NWF_CLS]: `${score} Letter Sound${getWordEnding(score)}/Minute`,
        [NWF_WRC]: `${score} Word${getWordEnding(score)}/Minute`,
    };

    return get(SCORE_SECTION, measure) ? SCORE_SECTION[measure] : score;
};

export const getRatesSection = (scoreObject, measure) => {
    const { score, correctResponses } = scoreObject;
    const RATES_SECTION = {
        [RAN]: (
            <>
                Time: <strong>{`${score} Seconds`}</strong>
                <br />
                Score: <strong>{`${correctResponses} Correct`}</strong>
            </>
        ),
        ...getSharedRatesSection(scoreObject),
    };
    return (
        get(RATES_SECTION, measure) || (
            <DefaultRatesSection scoreSection={getScoreSection(score, measure)} />
        )
    );
};
